<mat-form-field appearance="outline" class="template-autocomplete-field">
  <mat-label>Cím</mat-label>
  <input
    matInput
    type="text"
    [placeholder]=""
    [formControl]="searchControl"
    #searchInput
    [attr.tabindex]="inputTabIndex"
    [matAutocomplete]="templateAutocomplete"
    autocomplete="off"
  />


  <mat-autocomplete
    #templateAutocomplete="matAutocomplete"
    [displayWith]="displayTemplate"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option
      *ngFor="let option of options"
      [value]="option"
      class="template-option"
    >
      <div
        class="template-option__title"
        [innerHTML]="(option.autoIncrementId + '. ' + option.title) | highlightText:lastSearchTerm"
      ></div>
      <div
        class="template-option__description"
        [innerHTML]="option.description | highlightText:lastSearchTerm"
      ></div>
    </mat-option>

  </mat-autocomplete>
</mat-form-field>

